import { makeStyles } from "@material-ui/core";

const useRbRadioGroupStyles = makeStyles(() => ({
  root: (props) => ({
    display: props.variant === "grid" ? "grid" : undefined,
    gridGap:
      props.variant === "grid"
        ? `${props.rowGap}px ${props.columnGap}px`
        : undefined,
    gridTemplateColumns:
      props.variant === "grid"
        ? `repeat(${props.gridColumns}, 1fr)`
        : undefined,
    flexDirection: props.variant === "row" ? "row" : undefined,
    alignItems: props.variant === "column" ? "flex-start" : undefined,
    paddingLeft: 0,
    marginTop: props.variant === "grid" ? undefined : props.rowGap * -1,
    "&>.MuiFormControlLabel-root": {
      marginRight: props.variant === "grid" ? undefined : props.columnGap,
      marginTop: props.variant === "grid" ? undefined : props.rowGap,
      marginLeft: 0,
    },
  }),
}));

export default useRbRadioGroupStyles;
